// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"e978375d","299":"e978375d","864":"f5d3f5b9"}[chunkId] + ".chunk.css";
};